export default function(input, init) {
  return new Promise(function(resolve, reject) {
    var image = new Image;
    for (var key in init) image[key] = init[key];
    image.onerror = reject;
    image.onload = function() { resolve(image); };
    image.src = input;
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-fetch/src/image.js
// module id = 481
// module chunks = 0